import InstructionsLayout from "./InstructionsLayout.js";
import StepsScreenContent from "./StepsScreenContent.js";

const StepsScreen = ({ title, steps = [], nav = "back", children }) => {
  return (
    <InstructionsLayout nav={nav}>
      <StepsScreenContent title={title} steps={steps}>
        {children}
      </StepsScreenContent>
    </InstructionsLayout>
  );
};

export default StepsScreen;
